import {
    IMappingProfile,
    IQueryParams,
    IQueryParamsSymbol,
    PFWmsEntities,
} from '@pf/shared-common';
import { createMap, Mapper } from '@automapper/core';
import {
    entitySymbols,
    withArraySearchFilter,
    withDefaultEntityMetadata,
    withDefaultSearchParamsMappingConfiguration,
    withDefaultSearchParamsMetadata,
    withFragmentIdProp,
    withFragmentSearchFilter,
    withMetadata,
    withSearchFilter,
} from '@pf/shared-utility';
import {
    AuditCreate,
    AuditDto,
    AuditRead,
    AuditSearchParams,
} from '../../entities/audit.dto';
import {
    CustomFieldMetadataMap,
    ResourceAuthSymbol,
    UserFragmentSymbol,
} from '@pf/shared/util-platform';
import { withWarehouseSearchFilter } from '../wms-mapping.util';

const symbols = entitySymbols(PFWmsEntities.Audit);

withDefaultEntityMetadata<AuditDto>(symbols.dto, {
    assignedToUser: UserFragmentSymbol,
    auditDate: String,
    priority: String,
    resourceAuth: ResourceAuthSymbol,
    startDate: String,
    dueDate: String,
    item: Object,
    inventoryBundle: Object,
    warehouse: Object,
    auditType: Object,
    customFields: [CustomFieldMetadataMap.symbols.dto],
    auditScheduleId: String,
    status: String,
    auditCounts: [Object],
});

withDefaultEntityMetadata<AuditRead>(symbols.entity, {
    assignedToUser: UserFragmentSymbol,
    auditDate: String,
    priority: String,
    resourceAuth: ResourceAuthSymbol,
    startDate: String,
    dueDate: String,
    item: Object,
    inventoryBundle: Object,
    warehouse: Object,
    auditType: Object,
    customFields: [CustomFieldMetadataMap.symbols.dto],
    auditScheduleId: String,
    status: String,
    auditCounts: [Object],
});

withMetadata<AuditCreate>(symbols.createBody, {
    assignedToUserId: String,
    auditDate: String,
    priority: String,
    startDate: String,
    dueDate: String,
    warehouseId: String,
    itemId: String,
    inventoryBundleId: String,
    auditTypeId: String,
    resourceAuth: ResourceAuthSymbol,
    status: String,
    auditCounts: [Object],
});

withDefaultSearchParamsMetadata<AuditSearchParams>(symbols.searchParams, {
    itemId: String,
    auditStartDate: String,
    auditEndDate: String,
    containerId: String,
    zoneId: String,
    slotId: String,
    warehouseId: String,
    assignedToUserId: String,
    auditScheduleId: String,
    auditTypeId: String,
    search: String,
    createdStartDate: String,
    createdEndDate: String,
    modifiedStartDate: String,
    modifiedEndDate: String,
    priority: String,
    status: Array<string>,
});

export const AuditMetadataMap: IMappingProfile = {
    symbols,
    profile: (mapper: Mapper) => {
        createMap<AuditRead, AuditDto>(mapper, symbols.entity, symbols.dto);
        createMap<AuditDto, AuditRead>(mapper, symbols.dto, symbols.entity);
        createMap<AuditDto, AuditCreate>(
            mapper,
            symbols.dto,
            symbols.createBody,
            withFragmentIdProp('assignedToUser')
        );
        createMap<IQueryParams<AuditDto>, AuditSearchParams>(
            mapper,
            IQueryParamsSymbol,
            symbols.searchParams,
            withSearchFilter('priority'),
            withFragmentSearchFilter('assignedToUser'),
            withFragmentSearchFilter('auditType'),
            withArraySearchFilter('status'),
            withWarehouseSearchFilter(),
            ...withDefaultSearchParamsMappingConfiguration()
        );
    },
};
